import { Autocomplete, SxProps, TextField } from '@mui/material'
import { forwardRef, useRef, useState } from 'react'
import { getSupplierLabel } from '../../context/buy_context'
import { SupplierInfo } from '../../context/supplier_context'
import { listSuppliers } from '../../services/supplier'
import { useTranslation } from 'react-i18next'
import { useCoin } from '../../context/coin_context'

interface Props {
    supplier: SupplierInfo | null
    returnSupplier(supplier: SupplierInfo | null): void
    hideNewSupplier?: boolean
    sx?: SxProps
    size?: 'small' | 'medium'
    customLabel?: string
    disabled?: boolean
}

export const SupplierSearchBar = forwardRef<HTMLInputElement, Props>(
    (
        {
            supplier,
            returnSupplier,
            hideNewSupplier,
            sx,
            size = 'small',
            customLabel,
            disabled,
        },
        ref
    ) => {
        const { t } = useTranslation()
        const [suppliers, setSuppliers] = useState<SupplierInfo[]>([])
        const timeout = useRef<NodeJS.Timeout>()
        const { coins } = useCoin()

        const searchSuppliers = async (value: string) => {
            if (!value) return
            try {
                const res = await listSuppliers(
                    {
                        skip: 1,
                        take: 10,
                        search: value,
                    },
                    coins
                )
                setSuppliers(res.data)
            } catch (error) {}
        }

        return (
            <>
                <Autocomplete
                    options={suppliers}
                    filterOptions={(p) => p}
                    getOptionLabel={getSupplierLabel}
                    sx={{ width: '100%', ...sx }}
                    value={supplier}
                    onChange={(e, newSupplier) => {
                        returnSupplier(newSupplier)
                    }}
                    blurOnSelect={true}
                    disabled={disabled}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            onChange={(e) => {
                                const { value } = e.target
                                clearTimeout(timeout.current)
                                timeout.current = setTimeout(() => {
                                    searchSuppliers(value)
                                }, 250)
                            }}
                            inputRef={ref}
                            label={
                                customLabel
                                    ? t(customLabel)
                                    : t('Buscar proveedor')
                            }
                            sx={{ width: '100%' }}
                            size={size}
                        />
                    )}
                />
            </>
        )
    }
)
